import React from 'react'

export default function TimelineHeaderUi({
  campaign,
  dateRange,
  actions = null,
  embedded = false,
  activeTab = 'timeline',
  onTabChange,
}) {
  const initials = campaign?.name?.slice(0, 2).toUpperCase()

  if (embedded) {
    return (
      <div className="shrink-0 border-b border-rb-widget-border bg-white px-4 pt-3 dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex min-w-0 items-center gap-3">
            <CampaignBadge campaign={campaign} initials={initials} className="p-3 text-sm font-semibold" />
            <HeaderTitle campaignName={campaign?.name} dateRange={dateRange} titleClassName="text-lg" dateClassName="text-xs" />
          </div>
          {actions}
        </div>
        <TimelineHeaderTabs activeTab={activeTab} onTabChange={onTabChange} className="mt-2" />
      </div>
    )
  }

  return (
    <div className="border-b-2 border-rb-widget-border bg-white pt-6 px-4 transition-all duration-300 dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode">
      <div className="flex h-full flex-col justify-between">
        <div className="flex items-start justify-between gap-4 pb-0">
          <div className="flex min-w-0 items-center gap-4 mb-6">
            <CampaignBadge campaign={campaign} initials={initials} className="p-4" />
            <HeaderTitle campaignName={campaign?.name} dateRange={dateRange} />
          </div>
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </div>
        <TimelineHeaderTabs activeTab={activeTab} onTabChange={onTabChange} />
      </div>
    </div>
  )
}

function CampaignBadge({ campaign, initials, className = '' }) {
  return (
    <span
      className={`shrink-0 rounded-lg border border-rb-widget-border text-white dark:border-rb-dark-mode-lighter ${className}`}
      style={{ backgroundColor: campaign?.theme_color }}
    >
      {initials}
    </span>
  )
}

function HeaderTitle({
  campaignName,
  dateRange,
  titleClassName = 'text-2xl',
  dateClassName = 'text-sm',
}) {
  return (
    <div className="min-w-0">
      <p className="max-w-[220px] truncate text-rb-lighter-grey dark:text-gray-400">{campaignName}</p>
      <div className="flex flex-wrap items-center gap-2">
        <h1 className={`${titleClassName} font-bold dark:text-white`}>Timeline</h1>
        {dateRange ? (
          <span className={`${dateClassName} text-rb-lighter-grey dark:text-gray-400`}>{dateRange}</span>
        ) : null}
      </div>
    </div>
  )
}

function TimelineHeaderTabs({
  activeTab,
  onTabChange,
  className = '',
}) {
  if (!onTabChange) return null

  const tabs = [
    { id: 'timeline', label: 'Timeline' },
    { id: 'notes', label: 'Notes' },
  ]

  return (
    <div className={`flex gap-6 ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`border-b-2 pb-2 text-sm font-medium transition-colors ${
              isActive
                ? 'border-rb-green text-rb-green'
                : 'border-transparent text-rb-lighter-grey hover:text-rb-black dark:text-gray-400 dark:hover:text-white'
            }`}
          >
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
